<iframe [srcdoc]="sanitize ? (html | sanitizeHtml) : html" class="w-100 h-100"></iframe>
